import React from 'react';
import autoBind from 'react-autobind';
import { Form, Table, Button, Tooltip, Drawer, Input, message } from 'antd';
import { FormOutlined } from '@ant-design/icons';
//
import CustomComponent from '../../components/CustomComponent';
import Utils from '../../components/Utils';
import config from '@/config/config';
//
import '../../assets/stylesheets/AdminSearchUsersView.less';
//
export default class CommonActivationsTable extends CustomComponent {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      sortedInfo: { columnKey: 'createdOn', order: 'descend' },
      isDrawerVisible: false,
      notes: '',
      hoveredNotes: null,
    };
  }

  //Table support
  handleFilterChange(pagination, filters, sorter) {
    this.setState({ sortedInfo: sorter, filters });
  }

  productFilter(data, productFilter) {
    if (!data || data.length === 0 || !productFilter) return data;
    const filteredData = data.filter((item) => item.productID === productFilter.id);
    return filteredData;
  }

  getTableRowProps(record) {
    return {
      onClick: () => this.props.onRow && this.props.onRow(record),
      onMouseEnter: () => this.setState({ hoveredNotes: record.notes }),
      onMouseLeave: () => this.setState({ hoveredNotes: null }),
    };
  }
  _handleOpenSession = (sessionID) => {
    const { app } = this.props;
    app.urlManager.openExternalPageWithParams(config.ApplicationRoutes.session, null, sessionID);
  };

  showEditDrawer(license) {
    this.setState({
      isDrawerVisible: true,
      currentLicense: license,
      notes: license.notes || '',
    });
  }

  handleDrawerOk() {
    const { currentLicense, notes } = this.state;
    this.handleUpdateLicenseConsumption(currentLicense.id, notes);
    this.setState({ isDrawerVisible: false, currentLicense: null, notes: '' });
  }

  handleDrawerCancel() {
    this.setState({ isDrawerVisible: false, currentLicense: null, notes: '' });
  }

  //UI
  render() {
    const isAdmin = this.props.app.isAdmin();
    let { sortedInfo } = this.state;
    sortedInfo = sortedInfo || {};
    const columns = [
      {
        title: 'License ID',
        dataIndex: 'licenseID',
        key: 'licenseID',
        sortOrder: sortedInfo.columnKey === 'licenseID' && sortedInfo.order,
        sorter: (a, b) => a.licenseID.localeCompare(b.licenseID),
      },
      {
        title: 'Activation Key',
        dataIndex: 'activationKey',
        key: 'activationKey',
        sortOrder: sortedInfo.columnKey === 'activationKey' && sortedInfo.order,
        sorter: (a, b) => a.activationKey.localeCompare(b.activationKey),
      },
      {
        title: 'Product',
        key: 'productName',
        sortOrder: sortedInfo.columnKey === 'productName' && sortedInfo.order,
        sorter: (a, b) => a.productName.localeCompare(b.productName),
        render: (props) => (props?.productName ? props?.productName : '-'),
      },
      {
        title: 'Session',
        key: 'sessionID',
        sortOrder: sortedInfo.columnKey === 'sessionID' && sortedInfo.order,
        sorter: (a, b) => a.sessionID.localeCompare(b.sessionID),
        render: (props) =>
          isAdmin ? (
            <Button
              type="link"
              onClick={() => this._handleOpenSession(props?.sessionID)}
            >
              {props?.sessionID ? props?.sessionID : '-'}
            </Button>
          ) : (
            (props?.sessionID ? props?.sessionID : '-')
          ),
      },
      {
        title: 'Student',
        dataIndex: 'name',
        key: 'name',
        sortOrder: sortedInfo.columnKey === 'name' && sortedInfo.order,
        sorter: (a, b) => a.name.localeCompare(b.name),
      },
      {
        title: 'Date',
        dataIndex: 'createdOn',
        key: 'createdOn',
        render: (createdOn) => (createdOn ? Utils.getDateOnUIFormatByTimestamp(createdOn) : ''),
        sorter: (a, b) => a.createdOn - b.createdOn,
        sortOrder: sortedInfo.columnKey === 'createdOn' && sortedInfo.order,
      },
      {
        title: 'Actions',
        width: '12%',
        key: 'Actions',
        render: (props) => {
          return (
            <span className="tableButtonContainer">
              {this.props.app.isAdmin() && (
                <Tooltip placement="bottomLeft" title="Edit Notes">
                  <Button
                    variant="none"
                    icon={<FormOutlined />}
                    shape="circle"
                    onClick={(e) => {
                      e.stopPropagation();
                      this.showEditDrawer(props);
                    }} style={{ marginLeft: '8px' }}
                  />
                </Tooltip>
              )}
            </span>
          );
        },
      },
    ];
    const filteredData = this.productFilter(this.props.consumptions, this.props.productFilter);

    const props = {
      loading: this.props.isLoading,
      onChange: this.handleFilterChange,
      locale: { emptyText: 'No Licenses found!' },
      pagination: { pageSize: 50, hideOnSinglePage: true, showSizeChanger: false, position: ['bottomCenter'] },
    };
    return (
      <>
        <Tooltip position="top" title={this.state.hoveredNotes} visible={!!this.state.hoveredNotes}>
          <Table columns={columns} dataSource={filteredData} onRow={this.getTableRowProps} {...props} />
        </Tooltip>
        {this._renderNotesDrawer()}
      </>
    );
  }

  _renderNotesDrawer() {
    return (
      <Drawer
        width={400}
        title="Edit Notes"
        open={this.state.isDrawerVisible}
        onClose={() => this.handleDrawerCancel()}
        footer={
          <>
            <Button style={{ marginRight: 4 }} type="primary" onClick={() => this.handleDrawerOk()}>
              Save
            </Button>
            <Button type="secondary" onClick={() => this.handleDrawerCancel()}>
              Cancel
            </Button>
          </>
        }
      >
        <Input.TextArea value={this.state.notes} onChange={(e) => this.setState({ notes: e.target.value })} />
      </Drawer>
    );
  }

  //API
  async handleUpdateLicenseConsumption(consumptionID, notes) {
    const resp = await this.props.app.license.licenseConsumption.updateLicenseConsumption(consumptionID, { notes });

    if (resp.statusCode === 200) {
      message.success('Note updated successfully!');
      this.props.reload();
    } else {
      this.props.app.alertController.showAPIErrorAlert(null, resp);
    }
  }
}
